import type * as React from 'react'
import { Link } from 'react-router'

export const Logo: React.VoidFunctionComponent = () => (
    <div className="logo">
        <h1>
            <Link to="/">Verbum</Link>
        </h1>{' '}
        анлайнавы слоўнік
    </div>
)
